import { render, staticRenderFns } from "./PopupProductsPromotion.vue?vue&type=template&id=0c66633f"
import script from "./PopupProductsPromotion.vue?vue&type=script&lang=js"
export * from "./PopupProductsPromotion.vue?vue&type=script&lang=js"
import style0 from "./PopupProductsPromotion.vue?vue&type=style&index=0&id=0c66633f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports